import * as Yup from 'yup'



export const validationSchemas = (isRechaza, isAjustado, montoNetoCompara) => {
  let validationObject = { };
  if(isRechaza){

    validationObject["comentario"] = Yup.string().required('Este campo es obligatorio.')
  }else {
    validationObject["comentario"] = Yup.string().test(
        "len",
        "No puede exeder 1000 caracteres..",
        (val) => {
          if (val === undefined) {
            return true;
          }
          return val.length === 0 || (val.length >= 0 && val.length <= 1000);
        }
        )
    
  }
  if(isAjustado){
    validationObject["porcAjustado"] = Yup.number().required('Este campo es obligatorio').min(0, "El porciento no puede ser negativo").max(100,"El porciento no puede ser mayor a 100");
   
    validationObject["montoAjustado"] = Yup.string().test(
      "len",
      "No puede ser mayor a monto neto",
      (val) => {
        if (val === undefined) {
          return true;
        }
        return parseInt(val.replace(/\./g, '')) >= 0 && parseInt(val.replace(/\./g, ''))  <= montoNetoCompara;
      }
    ); 
    
   
  }
  
  validationObject["estadoSolicitud"] = Yup.string().required('Este campo es obligatorio.');
  return Yup.object().shape(validationObject);
}

